import { Component, Input } from '@angular/core';

@Component({
    selector: 'epi-container',
    templateUrl: './epi-container.component.html',
    standalone: false
})
export class EpiContainer {
    @Input() header: string = '';
    @Input() visible: boolean = true;
}